import { render } from "./_image.vue?vue&type=template&id=3c91e08e"
import script from "./_image.vue?vue&type=script&lang=js"
export * from "./_image.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__